export enum ComponentRules {
  REQUIRED = 'REQUIRED',
  MIN_LENGTH = 'MIN_LENGTH',
  MAX_LENGTH = 'MAX_LENGTH',
  MIN_VALUE = 'MIN_VALUE',
  MAX_VALUE = 'MAX_VALUE',
  CUSTOM = 'CUSTOM',
}

export interface ComponentRule {
  type: ComponentRules;
}

export interface RequiredRule extends ComponentRule {}

export interface MinLengthRule extends ComponentRule {
  minLength: number;
}

export interface MaxLengthRule extends ComponentRule {
  maxLength: number;
}

export interface MinValueRule extends ComponentRule {
  minValue: number;
}

export interface MaxValueRule extends ComponentRule {
  maxValue: number;
}

export interface CustomRule extends ComponentRule {
  rule: (value: any) => boolean;
}

export interface ComponentErrorStatus {
  error: boolean;
  rules: ComponentRule[];
  message: string;
}
